/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:50 PM
 *
 */

import { utcToZonedTime } from 'date-fns-tz';

export const utcDateToLocal = (date: Date) => {
  // eslint-disable-next-line new-cap
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  try {
    return utcToZonedTime(new Date(date).getTime() * 1000, timezone).toLocaleString();
  } catch {
    return 'Not Available';
  }
};
